import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const query = searchQuery.trim().toLowerCase();
    if (!query) return;

    if (query.includes('cutch') || query.includes('catechu')) {
      navigate('/cutch');
    } else if (query.includes('acacia')) {
      navigate('/acacia-powder');
    } else if (query.includes('quebracho') || query.includes('tannin')) {
      navigate('/quebracho-tannins');
    } else if (query.includes('desi katha')) {
      navigate('/desi-katha');
    } else if (query.includes('machine katha') || query.includes('machine')) {
      navigate('/machine-katha');
    } else if (query.includes('katha')) {
      navigate('/desi-katha');
    } else if (query.includes('export')) {
      navigate('/export');
    } else if (query.includes('quality') || query.includes('sustainability')) {
      navigate('/quality-sustainability');
    } else if (query.includes('about') || query.includes('who')) {
      navigate('/who-we-are');
    } else if (query.includes('what') || query.includes('do')) {
      navigate('/what-we-do');
    } else if (query.includes('contact')) {
      navigate('/contact');
    } else {
      navigate('/');
    }

    setSearchQuery('');
    setSearchOpen(false);
    setMenuOpen(false);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Escape') {
      setSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <header>
      <div className="top-bar">
        <div className="top-left">
          <span>📞 +91 9665621383</span>
          <span>✉️  info@sachinkathindustries.com</span>
        </div>
        <div className="top-right">

          {/* ✅ LinkedIn Icon */}
          <a href="https://www.linkedin.com/company/sachin-kath-industries/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect x="2" y="9" width="4" height="12"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </a>

          {/* ✅ Instagram Icon (fixed - filled path instead of stroke) */}
          <a href="https://www.instagram.com/sachinkath_industries/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
            </svg>
          </a>

          {/* Facebook Icon */}
          <a href="https://www.facebook.com/profile.php?id=61591097447895" target="_blank" rel="noreferrer" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 1.885-.287 1.782h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
            </svg>
          </a>

        </div>
      </div>

      <div className="navbar">
        <div className="logo">
          <Link to="/">
            <img src="/sklogo.png" alt="Sachin Kath Industries" />
          </Link>
          <h1 className="brand-name">
            <span className="brand-primary">SACHIN KATH</span>
            <span className="brand-secondary">INDUSTRIES</span>
          </h1>
        </div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</div>

        <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}> Home</Link>

          <div className="dropdown">
            <a href="#"> About Us ▾</a>
            <div className="dropdown-menu">
              <Link to="/who-we-are" onClick={() => setMenuOpen(false)}>Who We Are</Link>
              <Link to="/what-we-do" onClick={() => setMenuOpen(false)}>What We Do</Link>
            </div>
          </div>

          <div className="dropdown">
            <a href="#">Our Products ▾</a>
            <div className="dropdown-menu">
              <Link to="/cutch" onClick={() => setMenuOpen(false)}>Cutch/Catechu</Link>
              <Link to="/acacia-powder" onClick={() => setMenuOpen(false)}>Cutch Blocks</Link>
              <Link to="/quebracho-tannins" onClick={() => setMenuOpen(false)}>Quebracho Tannins</Link>
              <Link to="/indian-katha" onClick={() => setMenuOpen(false)}>Desi Katha</Link>
              <Link to="/machine-katha" onClick={() => setMenuOpen(false)}>Machine Katha</Link>
            </div>
          </div>

          <Link to="/export" onClick={() => setMenuOpen(false)}>Export</Link>

          <Link to="/quality-sustainability" onClick={() => setMenuOpen(false)}>Quality & Sustainability</Link>

          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>

          <div className="search-wrapper">
            <button className="search-icon-btn" onClick={() => setSearchOpen(!searchOpen)} aria-label="Search">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </button>
            <form className={`search-box ${searchOpen ? 'open' : ''}`} onSubmit={handleSearchSubmit}>
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearchKeyDown}
                autoFocus={searchOpen}
              />         
            </form>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;